<template>
  <!--
    Everything the upload/analysis run has to tell the user, in one place:
    oversized files, skipped log file names, per-file analysis failures and the
    generic error message. Used twice by FileControl: inside the blocking error
    box (tone "error") and as a non-blocking notice above the file list
    (tone "warning"), see DS-1317.
  -->
  <div class="file-notices" :class="tone">
    <div v-if="dataStore.oversizedFiles.length" class="notice-text">
      <span v-if="dataStore.oversizedFiles.length === 1">
        {{ t('fileUpload.fileSizeSingleError', { file: dataStore.oversizedList }) }}
      </span>
      <span v-else>
        {{ t('fileUpload.fileSizeMultipleError', { files: dataStore.oversizedList }) }}
      </span>
    </div>
    <div v-if="dataStore.invalidLogFileName.length" class="notice-text">
      <span v-if="dataStore.invalidLogFileName.length === 1">
        {{ t('fileUpload.logFileNameSingleError', { file: dataStore.invalidLogFileNameList }) }}
      </span>
      <span v-else>
        {{ t('fileUpload.logFileNameMultipleError', { files: dataStore.invalidLogFileNameList }) }}
      </span>
      <span class="notice-hint">{{ t('fileUpload.logFileNameHint') }}</span>
    </div>
    <div v-for="failure in dataStore.analyzeFailures" :key="failure.nameId" class="notice-text">
      {{ t('fileUpload.analyzeFailed', { file: failure.file, reason: t(failure.reason.key, failure.reason.params || {}) }) }}
    </div>
    <div v-if="dataStore.errorMessage" class="notice-text">
      {{ t(dataStore.errorMessage.key, dataStore.errorMessage.params || {}) }}
    </div>
  </div>
</template>

<script setup>
import { useDataStore } from '@/stores/dataStore.js'
import { useI18n } from 'vue-i18n'

defineProps({
  tone: {
    type: String,
    default: 'warning',
    validator: value => ['error', 'warning'].includes(value)
  }
})

const { t } = useI18n()
const dataStore = useDataStore()
</script>

<style scoped>
.file-notices {
  display: flex;
  flex-direction: column;
}

.notice-text {
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  color: var(--errorbox-text-color);
  margin: 6px 0;
}

.notice-hint {
  display: block;
  font-weight: 500;
  margin-top: 3px;
}

.file-notices.warning {
  background-color: var(--errorbox-background-color);
  border-radius: 6px;
  padding: 6px 12px;
}
</style>
